export const AI_IMAGE_GENERATOR_MODAL_NAME = 'aiImageGenerator' as const;

export const DEFAULT_PROMPT = '';

export const IMAGE_ACCEPT_TYPES = 'image/*';

export const IMAGE_STYLES = {
  container: {
    width: '100%',
    maxWidth: 300,
    height: 300,
    objectFit: 'cover' as const,
    borderRadius: 1,
  },
  placeholder: {
    width: '100%',
    maxWidth: 300,
    height: 300,
    border: '2px dashed',
    borderRadius: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'gray ultra light',
  },
} as const;

export const BUTTON_STYLES = {
  minWidth: 120,
} as const;

export const DECIMAL_PLACES = 2;
